package horcrux.frontend.common.views.org

import mui.material.Link
import mui.material.Typography
import mui.material.TypographyAlign
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML.h2
import web.cssom.WhiteSpace

external interface PrivacyPolicyProps : Props

val PrivacyPolicy = FC<PrivacyPolicyProps> {
    h2 { +"Email and Password Data" }
    Typography {
        +"""• Your email will be stored securely using the Firebase Authentication service. It will not be shared with any third parties. In the future it will be used to send you informational emails about your Grok App account and product updates. You will have the option to opt out of these emails.
            • A hash of your password will be stored securely using the Firebase Authentication service. It will not be shared with third parties and will only be used to authenticate your Grok App account.
            • All data sent to Firebase Authentication is encrypted in transit using HTTPS. Any data stored in Firebase Authentication is encrypted at rest.
        """.trimIndent()
        this.paragraph = true
        this.align = TypographyAlign.left
        this.sx {
            this.whiteSpace = WhiteSpace.preLine
        }
    }
    h2 { +"Document and Question Data" }
    Typography {
        +"""• Your documents are imported to the The Grok App when you perform an "Import Documents" action. 
            • Any documents imported to the The Grok App are encrypted in transit using HTTPS.
            • Your documents will be stored securely in our Google Cloud account. They will be encrypted at rest using Google managed encryption.
            • They will only be accessible through your authenticated account unless if you share them.
            • The only third party your documents will be shared with is OpenAI via the OpenAI API.
              • Documents will be sent to the OpenAI API on import. This is necessary to generate embedding vectors for your documents, which enables the The Grok App to search through them to answer your questions.
              • Documents relevant to your question, along with your question, will be sent to the OpenAI API when you ask a question via The Grok App.
              • All data sent to the OpenAI API is encrypted via HTTPS.
              • OpenAI does not use data sent over the API to train its models.
              • A full explanation of the OpenAI privacy policy can be found here 
        """.trimIndent()
        Link {
            +"https://openai.com/enterprise-privacy"
            this.href = "https://openai.com/enterprise-privacy"
            this.variant = "p"
        }
        this.paragraph = true
        this.align = TypographyAlign.left
        this.sx {
            this.whiteSpace = WhiteSpace.preLine
        }
    }
    h2 { +"Analytics Data" }
    Typography {
        +"""• The browser app collects usage data using Google Analytics. This will only be used internally for diagnostic purposes. It will not be shared with any third parties.
            • The Chrome extension app does not collect any analytics data. 
        """.trimIndent()
        this.paragraph = true
        this.align = TypographyAlign.left
        this.sx {
            this.whiteSpace = WhiteSpace.preLine
        }
    }
}
